import { Link } from 'react-router-dom';
import '../App.css';
import Header from '../components/Header';
import { Helmet } from "react-helmet-async";

const HOME_MANAGER_VIDEO_VIMEO_ID = '1168098261';

function MeetTheTeam() {
  return (
    <>
    <Helmet>
        <title> Meet the Team at Whitstable House </title>
        <meta
          name="description"
          content="Meet the team at Whitstable House. From care and nursing staff to hospitality and management, each member of our team is committed to creating a safe, supportive and truly homely environment for our residents."
        />
        <link rel="canonical" href="https://www.whitstable.house/meet-the-team"/>
      </Helmet>

    <div className="page">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Header />

      <main id="main-content">
        <section className="content-section meet-the-team-page">
          <div className="meet-the-team-container">
            <h1>Meet the Team</h1>
            <p className="meet-the-team-intro">
              At Whitstable House, we are proud to have a dedicated and compassionate team at the heart of everything we do. From care and nursing staff to hospitality and management, each member of our team is committed to creating a safe, supportive and truly homely environment for our residents. Get to know the people who make our community so special.
            </p>
          </div>
        </section>

        <section className="content-section meet-the-team-manager">
          <div className="section__container">
            <div className="meet-the-team-video">
              <div className="nursing-video-wrapper">
                <iframe
                  src={`https://player.vimeo.com/video/${HOME_MANAGER_VIDEO_VIMEO_ID}?badge=0&autopause=0&player_id=0&app_id=58479`}
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  title="Graham Care - January - Home Manager"
                />
              </div>
            </div>
            <div className="section__text">
              <h3 className="meet-the-team-manager-name">Sharon Geary – Registered Manager at Whitstable House</h3>
              <div className="meet-the-team-manager-bio">
                <p>With over 42 years of experience in the care sector, our Home Manager, Sharon, brings a wealth of knowledge, compassion and dedication to Whitstable House. Passionate about seeing residents happy and fostering meaningful interactions between staff and those in our care, Sharon is committed to ensuring every resident enjoys the very best and most special time possible while living at Whitstable House.</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <section className="footer__enquiry">
          <div className="footer__enquiry-container">
            <Link to="/contact-us" className="footer__enquiry-link">
              Enquire about Whitstable House <span className="footer__arrow">▶</span>
            </Link>
          </div>
        </section>
        <div className="footer__container">
          <section className="contact-section">
            <div className="contact-section__content">
              <p>Whitstable House, Boorman Way, Whitstable CT5 3SE</p>
              <p>Copyright © Whitstable House</p>
            </div>
          </section>
        </div>
      </footer>
    </div>
    </>
  );
}

export default MeetTheTeam;
